import { DeliveryPriceLabel } from 'Components/pages/VehicleDetailsRedesign/sections/LocationSection/DeliveryPrice/DeliveryPrice';
import {
	getAvailableRowText,
	getCheapestTransportValue,
} from 'Components/pages/VehicleDetailsRedesign/sections/LocationSection/DeliveryTable/DeliveryTable.helpers';
import type { SpecSectionField } from 'Components/SpecSection/SpecSection.types';
import { FEATURES } from 'Context/FeaturesContext/FeaturesContextConsts';
import { prettyPostcode } from 'Utilities/formatters';

import { DeliveryLocationFieldValue } from './DeliveryLocationFieldValue/DeliveryLocationFieldValue';
import type { LocationFieldData } from './LocationSection.types';

export const LOCATION_FIELDS: SpecSectionField<LocationFieldData>[] = [
	{
		featureToggle: FEATURES.estimatedDeliveryCosts,
		fieldName: 'deliveryLocation',
		isVisible: ({ isFeatureEnabled }) => Boolean(isFeatureEnabled),
		label: ({ deliveryLocation, transportOptions }) => (
			<DeliveryPriceLabel
				values={{
					labelText: `Deliver to ${prettyPostcode(deliveryLocation.postcode)}`,
					requiresFerry: transportOptions?.requiresFerry!,
				}}
			/>
		),
		value: ({ transportOptions }: LocationFieldData): JSX.Element => {
			const transportValue = getCheapestTransportValue(transportOptions?.transportOptions || []);
			const content = (transportOptions?.requiresFerry ? 'tooltipContent.ferryWarning' : transportValue?.content) ?? '';
			const requiresFerry = Boolean(transportOptions?.requiresFerry);
			return (
				<DeliveryLocationFieldValue
					delivery={{
						content,
						drivingDistance: transportOptions?.drivingDistance,
						requiresFerry,
						transportValue,
					}}
				/>
			);
		},
	},
	{
		fieldName: 'availability',
		isVisible: () => true,
		label: () => <>Availability</>,
		value: ({ availability: { availableFrom, availableUntil } }) => (
			<>{getAvailableRowText({ availableFrom, availableUntil })}</>
		),
	},
];
